export const en = {
  files: {
    dropZone: {
      primary: 'Click here or drag file to this area',
      secondary: 'You can select one or a few files',
    },
    retry: 'Retry',
    addedOn: 'Added on',
    loadingFiles: 'Loading files...',
    saveFirst: 'Please save the record first before adding files',
    uploadSuccess: (fileName: string) => `${fileName} uploaded successfully`,
    uploadFailed: (fileName: string) => `Failed to upload ${fileName}`,
    deleteSuccess: (fileName: string) => `${fileName} deleted successfully`,
    deleteFailed: (fileName: string, error: string) =>
      `Failed to delete ${fileName}: ${error}`,
  },
  fields: {
    placeholder: {
      searchMaterial: 'Search for a material...',
    },
  },
  selectFields: {
    CRMContact: {
      placeholder: 'Select a contact',
    },
    CRMAccount: {
      placeholder: 'Select an account',
    },
    CRMAccountAddress: {
      placeholder: 'Select an account address',
    },
    CoreFacilityGroup: {
      placeholder: 'Select a facility group',
    },
    CoreFacility: {
      placeholder: 'Select a facility',
    },
    CoreUser: {
      placeholder: 'Select a user',
    },
    FilesFile: {
      placeholder: 'Select a file',
    },
    FinanceFinancialAccount: {
      placeholder: 'Select a financial account',
    },
    InventoryCategory: {
      placeholder: 'Select a category',
    },
    InventoryItem: {
      placeholder: 'Select an item',
    },
    InventoryItemGroup: {
      placeholder: 'Select an item group',
    },
    InventoryTag: {
      placeholder: 'Select an inventory tag',
    },
    containerInstance: {
      placeholder: 'Select container...',
      noContainersAvailable: 'No containers available',
      unassignedContainer: 'Unassigned Container',
      unknownType: 'Unknown Type',
    },
  },

  containerStatus: {
    atPort: 'At Port',
    inTransitToFacility: 'In Transit to Facility',
    atFacilityEmpty: 'At Facility (Empty)',
    atFacilityLoaded: 'At Facility (Loaded)',
    inTransitToPort: 'In Transit to Port',
    atPortReadyToShip: 'At Port (Ready to Ship)',
    shipped: 'Shipped',
    voided: 'Voided',
  },

  menu: {
    customerPortal: {
      root: 'Customer Portal',
      purchaseOrders: 'Purchase Orders',
      bookings: 'Bookings',
      loads: 'Loads',
      bills: 'Bills',
    },

    crm: {
      root: 'Account Mgmt.',
      accounts: {
        root: 'Accounts',
      },
    },

    facilities: {
      root: 'Facilities',
      management: {
        root: 'Facility Management',
        groups: 'Facility Groups',
        facilities: 'Facilities',
      },
    },

    files: {
      root: 'Files',
      explorer: 'File Explorer',
      shared: 'Shared with Me',
    },

    reports: {
      root: 'Reports',
    },

    inventory: {
      root: 'Inventory',
      levels: 'Inventory Levels',
      lots: 'Inventory Lots',
      tags: 'Inventory Tags',
      periods: 'Inventory Periods',
      locations: 'Locations',
      zones: 'Zones',
      cycleCountSchedules: 'Count Schedules',
      counts: 'Cycle Counts',
    },

    office: {
      root: 'Office',
    },

    finance: {
      root: 'Finance',
      overview: 'Overview',
      financialAccounts: 'Financial Accounts',
      balances: {
        root: 'Balances',
      },
      bills: {
        root: 'Bills',
      },
      invoices: {
        root: 'Invoices',
        overview: 'Overview',
        history: 'History',
      },
      payments: {
        root: 'Payments',
        list: 'List',
      },
    },

    trade: {
      root: 'Trade',
      overview: 'Overview',
      bookings: 'Bookings',
      loads: 'Loads',
      containers: 'Containers',
      salesOrders: 'Sales Orders',
      purchaseOrders: 'Purchase Orders',
      purchaseLoads: 'Purchase Loads',
      positions: 'Positions',
      scaleTickets: 'Scale Tickets',
      transactions: 'Transactions',
      sortingQueue: 'Sorting Queue',
      bookingTitle: (number: number) => `Booking ${number}`,
      loadTitle: (number: number) => `Load ${number}`,
      purchaseOrderTitle: (number: string) => `Purchase Order ${number}`,
      purchaseLoadTitle: (number: number) => `Purchase Load ${number}`,
      scaleTicketTitle: (number: number) => `Scale Ticket ${number}`,
      documents: 'Documents',
      bookingDetail: 'Booking Details',
      loadDetail: 'Load Details',
      purchaseOrderDetail: 'Purchase Order Details',
      purchaseLoadDetail: 'Purchase Load Details',
      scaleTicketDetail: 'Scale Ticket Details',
    },

    pricing: {
      root: 'Pricing',
      variables: 'Variables',
      counterpartyGroups: 'Pricing Groups',
      counterpartyGroupDetail: 'Pricing Group',
      defaultPriceList: 'Default Price List',
      customPriceLists: 'Custom Price Lists',
      customPriceListDetail: 'Custom Price List',
    },

    brokerage: {
      root: 'Brokerage',
      orders: 'Brokered Orders',
      orderDetail: 'Order Details',
      quotes: 'Quotes',
      quoteDetail: 'Quote Details',
      loads: 'Brokered Loads',
      loadDetail: 'Load Details',
      commodities: 'Commodities',
    },

    settings: {
      organization: 'Organization',
      inventory: 'Inventory',
      settings: 'Settings',
      customAttributes: 'Custom Attributes',
      jsonView: 'JSON View',
    },

    transportation: {
      root: 'Transportation',
      loadBoard: 'Load Board',
      drivers: 'Drivers',
      trucksAndTrailers: {
        root: 'Trucks & Trailers',
        transportationTypes: 'Transportation Types',
        trucks: 'Trucks',
        trailers: 'Trailers',
      },
      routes: 'Routes',
      map: 'Map',
      assets: {
        root: 'Assets',
        list: 'Asset List',
        types: 'Asset Types',
      },
      freight: {
        root: 'Freight',
        lanes: 'Freight Lanes',
        detentions: 'Detentions',
      },
      settings: {
        root: 'Settings',
        serviceTypes: 'Service Types',
      },
    },

    calendar: {
      root: 'Calendar',
    },

    production: {
      root: 'Production',
      workOrders: 'Work Orders',
      processingTypes: 'Processing Types',
      tollAgreements: 'Outbound Tolling',
      tollProcessingAgreements: 'Inbound Tolling',
    },

    automations: {
      root: 'Workflows',
      workflows: 'Automations',
      approvals: 'Approvals',
    },

    admin: {
      root: 'Admin',
      organizations: 'Organizations',
      users: 'Users',
      aiManagement: 'AI Management',
      agents: 'Agents',
      aiAgents: 'Agents',
      aiUsage: 'Usage',
      toolConfigurations: 'Tool Configurations',
    },
  },

  touchModeSwitch: {
    label: 'Touch Mode',
  },

  filters: {
    supplier: {
      placeholder: 'Search suppliers...',
    },
  },

  presence: {
    you: (name: string) => `${name} (You)`,
  },

  entityTabNotes: {
    internalNotes: 'Internal Notes',
    externalNotes: 'External Notes',
    discardChanges: 'Discard Changes',
    saveNotes: 'Save Notes',
    clearAll: 'Clear all',
    addNotesPlaceholder: 'Add notes here...',
    hiddenFrom: (counterparty: string) => `Hidden from ${counterparty}`,
    visibleTo: (counterparty: string) => `Visible to ${counterparty}`,
  },

  pageNotFound: '404 - Not Found',

  auth: {
    signUp: {
      title: 'Create your account',
      subtitle: 'Enter your email to get started',
      emailLabel: 'Email',
      continue: 'Continue',
      or: 'or',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      verificationEmailSent:
        'Verification email sent! Please check your inbox.',
      invalidCredentials: 'Invalid email or password',
      unexpectedError: 'An unexpected error occurred during signup',
    },
    checkEmail: {
      title: 'Check your email',
      sentVerificationLink: "We've sent a verification link to",
      linkExpiry:
        'Click the link in the email to complete your account setup. The link will expire in 7 days.',
      didntReceive: "Didn't receive the email?",
      tryAgain: 'Try again',
      backToSignIn: 'Back to sign in',
    },
    signUpSuccess: {
      defaultMessage: 'Account created successfully!',
      canSignIn: 'You can now sign in with your credentials',
      continueToSignIn: 'Continue to Sign In',
    },
    verifyEmail: {
      title: 'Complete your registration',
      subtitle: 'Fill in your details to finish setting up your account',
      firstName: 'First Name',
      lastName: 'Last Name',
      organizationName: 'Organization Name',
      timezone: 'Timezone',
      password: 'Password',
      passwordPlaceholder: 'Min. 8 characters',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter your password',
      completeSetup: 'Complete Setup',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      invalidLink: 'Invalid verification link',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
      passwordRequirements:
        'Password does not meet requirements. Please use a stronger password with a mix of uppercase, lowercase, numbers, and symbols.',
      verificationFailed: (reason: string) => `Verification failed: ${reason}`,
      unexpectedError: 'An unexpected error occurred during verification',
    },
    acceptInvitation: {
      title: 'Set Your Password',
      subtitle:
        "You've been invited to join the platform. Please set your password to complete your registration.",
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your password',
      processing: 'Processing...',
      submitButton: 'Set Password & Complete Setup',
      disclaimer:
        'By setting your password, you agree to access the platform with this account.',
      success: 'Success!',
      successMessage:
        'Your password has been set successfully. Redirecting to sign in...',
      invitationError: 'Invitation Error',
      invalidLink: 'Invalid invitation link - missing token',
      invalidInvitation: 'Invalid invitation',
      failedToAccept: 'Failed to accept invitation. Please try again.',
      processingError:
        'An error occurred while processing your invitation. Please try again.',
      goToSignIn: 'Go to Sign In',
      passwordsDoNotMatch: 'Passwords do not match',
    },
    customerInvitation: {
      title: 'Accept Invitation',
      subtitle: (accountName: string) =>
        `You've been invited to access ${accountName}'s customer portal. Please complete your registration below.`,
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter your first name',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter your last name',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      processing: 'Processing...',
      submitButton: 'Accept Invitation & Create Account',
      disclaimer:
        'By accepting this invitation, you agree to create an account and access the customer portal.',
      success: 'Success!',
      welcomeMessage: (orgName: string) =>
        `Welcome! Your account has been created for ${orgName}. You can now sign in to access the customer portal.`,
      redirecting: 'Redirecting to sign in...',
      invitationError: 'Invitation Error',
      loadingInvitation: 'Loading invitation...',
      invalidLink: 'Invalid invitation link - missing token',
      expiredInvitation:
        'This invitation has expired. Please contact the company for a new invitation.',
      alreadyAccepted:
        'This invitation has already been accepted. You can now sign in to access the customer portal.',
      cancelledInvitation:
        'This invitation has been cancelled. Please contact the company for a new invitation.',
      invalidToken:
        'Invalid invitation token. Please check your invitation link and try again.',
      loadError:
        'Unable to load invitation. Please try again or contact support.',
      failedToAccept:
        'Failed to accept invitation. Please try again or contact support.',
      processingError:
        'An error occurred while processing your invitation. Please try again.',
      goToSignIn: 'Go to Sign In',
    },
    signIn: {
      selectOrganization: 'Select an Organization',
    },
  },
};
